export default "__VITE_ASSET__d22b2fbb__"